/* eslint-disable react/prop-types */
import { Card, FormControl, Grid, Icon } from "@mui/material";
import { ConfigProvider, DatePicker, Select, theme as antdTheme } from "antd";
import Search from "antd/es/input/Search";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import dayjs from "dayjs";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTablePagination from "examples/Tables/DataTable/DataTablePagination";
import { useAxiosPrivate } from "hooks/useAxiosPrivate";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Switch } from "antd";
import ActivityDetailsModal from "./ActivityDetailsModal";
import MDBadge from "components/MDBadge";
import { actions } from "react-table";
import { isTaskCompletedAdded } from "service/Common";
import LeadDetailsModal from "./LeadDetailsModal";

const { Option } = Select;
const { RangePicker } = DatePicker;

const index = () => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [searchParams] = useSearchParams();
  const axiosPrivate = useAxiosPrivate();
  const [teamMember, setTeamMember] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [dates, setDates] = useState([dayjs(), dayjs()]);
  const [acitivityData, setActivityData] = useState([]);
  const navigate = useNavigate();
  const [apiParams, setApiParams] = useState({
    page,
    size: pageSize,
    type: searchParams.get("status"),
    leadStates: "",
    startDate: searchParams.get("startTime") || dayjs().startOf("day").unix(),
    endDate: searchParams.get("endTime") || dayjs().endOf("day").unix(),
  });
  useEffect(() => {
    setSelectedStatus(searchParams.get("status"));
    const prm = apiParams;
    const startEpoch = searchParams.get("startTime");
    const endEpoch = searchParams.get("endTime");
    if (startEpoch && endEpoch) {
      setDates([dayjs(Number(startEpoch) * 1000), dayjs(Number(endEpoch) * 1000)]);
    }
    getActivityData(prm, searchParams.get("employeeId"));
  }, []);

  const getActivityData = (params = {}, id) => {
    setLoading(true);
    const query = { ...params };
    if (query.type === "All") delete query.type;
    if (query.type !== "Cold Call") {
      delete query.taskStatus;
    }
    if (query.type === "Cold Call") {
      delete query.completed;
    }
    if (!query.search?.trim()) {
      delete query.search;
    }
    if (id != null) {
      query.id = id;
    }
    // if (query?.type === "Cold Call" || query?.type === "Missed") {
    //   delete query["startDate"];
    //   delete query["endDate"];
    // }
    if (query?.type === "Missed") {
      delete query["startDate"];
      delete query["endDate"];
    }
    // query.completed = false;
    const queryString = new URLSearchParams(query).toString();
    const url =
      id == null
        ? `om/list-all-activity?${queryString}`
        : `om/list-activities-teams?${queryString}`;
    let options = {
      method: "GET",
      url,
    };
    return axiosPrivate(options)
      .then((response) => {
       
        setActivityData(response?.data?.data?.content);
        setTotalCount(response?.data?.data?.totalElements);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleChange = (params) => {
    if (!params) return;
    setDates(params);
    const startEpoch = params[0].startOf("day").unix();
    const endEpoch = params[1].endOf("day").unix();
    setApiParams((prev) => ({
      ...prev,
      startDate: startEpoch,
      endDate: endEpoch,
    }));
    const prm = apiParams;
    prm.startDate = startEpoch;
    prm.endDate = endEpoch;
    getActivityData(prm, searchParams.get("employeeId"));
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [open, setOpen] = useState(false);
  const openDetailsModal = (activity) => {
    setSelectedActivity(activity);
    setOpen(true);
  };
  const handleTabChange = (status) => {
    const prm = apiParams;
    prm.type = status;
    setSelectedStatus(status);
    getActivityData(prm, searchParams.get("employeeId"));
  };

  const [doneToggleEnabled, setDoneToggleEnabled] = useState(false);

  const handleShowDone = (checked) => {
    setDoneToggleEnabled(checked);
    const prm = apiParams;
    prm.completed = checked;
    getActivityData(prm, searchParams.get("employeeId"));
  };

  const handleLeadStateChange = (state) => {
    const prm = apiParams;
    prm.leadStates = state;
    getActivityData(prm, searchParams.get("employeeId"));
  };

  const leadColors = {
    Cold: "#F7A829",
    Warm: "#2EBDC5",
    Hot: "#28e175ff",
    Onhold: "#95a5a6",
    Win: "#087b1dff",
    Fresh: "#1abc9c",
    Marketing: "#f38131ff",
  };

  const columns = useMemo(
    () => [
      { Header: "Assigned To", accessor: "assigned_to" },
      { Header: "Activity Type", accessor: "taskType" },
      { Header: "lead state", accessor: "leadState" },
      { Header: "status", accessor: "status" },
      { Header: "Activity Scheduled On", accessor: "taskScheduledOn" },
      { Header: "Lead Name", accessor: "leadName" },
      { Header: "Action", accessor: "action" },
    ],
    []
  );

  const getRows = (data) => {
    return data.map((item) => ({
      taskType: (
        <MDTypography variant="overline" fontWeight="small">
          {item?.taskType}
        </MDTypography>
      ),
      leadName: (
        <MDTypography
          variant="overline"
          fontWeight="small"
          sx={{
            display: "inline-block",
            borderBottom: "2px solid",
            borderColor: "info.main",
            lineHeight: "1",
            paddingBottom: "4px",
            cursor: "pointer",
            color: "info.main",
            "&:hover": {
              color: "info.main",
            },
          }}
          onClick={() => openLeadDetails(item?.leadId)}
        >
          {item?.lead_details?.leadName}
        </MDTypography>
      ),

      leadState: (
        <MDTypography
          variant="caption"
          fontWeight="medium"
          sx={{
            backgroundColor: leadColors[item?.leadState] || "#9e9e9e",
            color: "#fff",
            px: 1.2,
            py: 0.4,
            borderRadius: "8px",
            display: "inline-block",
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: 1.2,
          }}
        >
          {item?.leadState}
        </MDTypography>
      ),
      status: (
        <MDTypography
          variant="overline"
          fontWeight="small"
          color={isTaskCompletedAdded(item?.taskType, item?.status) ? "success" : "text"}
        >
          {item?.status}
        </MDTypography>
      ),

      assigned_to: (
        <MDTypography variant="overline" fontWeight="small">
          {item?.assigned_to}
        </MDTypography>
      ),
      taskScheduledOn: (
        <MDTypography variant="overline" fontWeight="small">
          {dayjs.unix(item?.taskScheduledOn).format("DD MMM YYYY, hh:mm A")}
        </MDTypography>
      ),
      action: (
        <MDTypography component="a" href="#" color="text" onClick={() => openDetailsModal(item)}>
          <Icon>visibility</Icon>
        </MDTypography>
      ),
    }));
  };



  const [openLeadModal, setOpenLeadModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const openLeadDetails = (leadId) => {
    setSelectedLeadId(leadId);
    setOpenLeadModal(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox
        py={0}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <MDBox>
          {searchParams.get("employeeName")
            ? `Selected ${searchParams.get("employeeName")}`
            : "Selected (self)"}
        </MDBox>
        <MDBox display="flex" gap={2} flexWrap="wrap">
          {["All", "Cold Call", "Missed", "Follow up", "Meeting", "Site Visit"].map((status) => {
            const isSelected = selectedStatus === status;
            const isMissed = status === "Missed";
            return (
              <MDButton
                key={status}
                size="small"
                onClick={() => handleTabChange(status)}
                variant={isSelected ? "contained" : "outlined"}
                color={isSelected ? (isMissed ? "primary" : "success") : "info"}
              >
                {status}
              </MDButton>
            );
          })}
        </MDBox>
      </MDBox>
      <MDBox
        py={2}
        display="flex"
        gap={1}
        flexWrap="wrap"
        justifyContent="flex-end"
        alignItems="center"
      >
        {selectedStatus != "Missed" && (
          <>
            <MDBox>Done</MDBox>
            <Switch
              checked={doneToggleEnabled}
              onChange={handleShowDone}
              style={{
                transform: "scale(0.85)", // shrink switch like RN scaleX/Y
              }}
              checkedChildren={null} // no text inside
              unCheckedChildren={null}
              className="custom-switch"
            />
          </>
        )}

        <FormControl
          variant="outlined"
          sx={{
            minWidth: { xs: "100%", sm: 200, md: 220 },
          }}
        >
          {
            <>
              <ConfigProvider
                theme={{
                  algorithm: darkMode ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
                  components: {
                    Select: {
                      colorBgContainer: darkMode ? "#1a2035" : "#fff", // input box
                      colorText: darkMode ? "#fff" : "#000",
                      colorBorder: darkMode ? "#475894" : "#d9d9d9",
                      colorPrimary: darkMode ? "#1890ff" : "#1890ff",
                      optionActiveBg: darkMode ? "#1f2937" : "#f5f5f5",
                      optionSelectedBg: darkMode ? "#1a243bff" : "#e6f4ff",
                    },
                  },
                }}
              >
                <Select
                  placeholder="Select Lead status"
                  options={["Cold", "Warm", "Hot", "Win", "Onhold"].map((item) => ({
                    label: item,
                    value: item,
                  }))}
                  onChange={handleLeadStateChange}
                />
              </ConfigProvider>
            </>
          }
        </FormControl>
        {selectedStatus != "Missed" && (
          <MDBox
            sx={{
              minWidth: { xs: "100%", sm: 220, md: 260 },
            }}
          >
            <ConfigProvider
              theme={{
                algorithm: darkMode ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
                components: {
                  DatePicker: {
                    colorBgContainer: darkMode ? "#1a2035" : "#fff",
                    colorText: darkMode ? "#fff" : "#000",
                    colorBorder: darkMode ? "#475894" : "#d9d9d9",
                    colorBgElevated: darkMode ? "#1f2937" : "#fff",
                    colorPrimary: darkMode ? "#1890ff" : "#1890ff",
                  },
                },
              }}
            >
              <RangePicker
                value={dates}
                onChange={handleChange}
                style={{ minWidth: 250 }}
                allowClear={false}
              />
            </ConfigProvider>
          </MDBox>
        )}
      </MDBox>

      <Grid item xs={12} py={4}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              Activities
            </MDTypography>
          </MDBox>
          <MDBox pt={3}>
            <DataTablePagination
              table={{
                columns,
                rows: getRows(acitivityData),
                totalCount,
                pageCount: Math.ceil(totalCount / pageSize),
              }}
              loading={loading}
              page={page}
              pageSize={pageSize}
              onPageChange={(p) => {
                setPage(p);
                const prm = apiParams;
                prm.page = p;
                getActivityData(prm, searchParams.get("employeeId"));
              }}
              onPageSizeChange={(s) => {
                console.log(s);
              }}
            />
          </MDBox>
          <ActivityDetailsModal open={open} onClose={handleClose} task={selectedActivity} />
          <LeadDetailsModal
            open={openLeadModal}
            onClose={() => {
              setOpenLeadModal(!openLeadDetails);
            }}
            leadId={selectedLeadId}
          />
        </Card>
      </Grid>
    </DashboardLayout>
  );
};

export default index;
